import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse, SpiritoryWebEndpoints } from '@/types/api/api-v2';

export default async function getSkuId(slug: string) {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<string>>(
      `/sku/${slug}/id` as SpiritoryWebEndpoints,
      undefined
    );

    return data;
  } catch (err) {
    throw err;
  }
}
